function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: inline-block;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  z-index: 1000;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  color: white;\n  background-color: rgba(0, 0, 0, 0.9);\n  border-radius: ",
        ";\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: ",
        ";\n  transition: opacity ",
        ";\n  \n  /* Arrow */\n  &::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    border: 5px solid transparent;\n    \n    ",
        "\n  }\n  \n  /* Position styles */\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
var TooltipWrapper = styled.div(_templateObject());
var TooltipContent = styled.div(_templateObject1(), function(props) {
    var _props_theme_radius, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_radius = _props_theme.radius) === null || _props_theme_radius === void 0 ? void 0 : _props_theme_radius.md) || '0.375rem';
}, function(props) {
    return props.$visible ? 1 : 0;
}, function(props) {
    var _props_theme_transition, _props_theme;
    return ((_props_theme = props.theme) === null || _props_theme === void 0 ? void 0 : (_props_theme_transition = _props_theme.transition) === null || _props_theme_transition === void 0 ? void 0 : _props_theme_transition.fast) || '150ms ease';
}, function(props) {
    switch(props.$position){
        case 'top':
            return "\n            bottom: -10px;\n            left: 50%;\n            transform: translateX(-50%);\n            border-top-color: rgba(0, 0, 0, 0.9);\n          ";
        case 'bottom':
            return "\n            top: -10px;\n            left: 50%;\n            transform: translateX(-50%);\n            border-bottom-color: rgba(0, 0, 0, 0.9);\n          ";
        case 'left':
            return "\n            right: -10px;\n            top: 50%;\n            transform: translateY(-50%);\n            border-left-color: rgba(0, 0, 0, 0.9);\n          ";
        case 'right':
            return "\n            left: -10px;\n            top: 50%;\n            transform: translateY(-50%);\n            border-right-color: rgba(0, 0, 0, 0.9);\n          ";
    }
}, function(props) {
    switch(props.$position){
        case 'top':
            return "\n          bottom: 100%;\n          left: 50%;\n          transform: translateX(-50%);\n          margin-bottom: 0.5rem;\n        ";
        case 'bottom':
            return "\n          top: 100%;\n          left: 50%;\n          transform: translateX(-50%);\n          margin-top: 0.5rem;\n        ";
        case 'left':
            return "\n          right: 100%;\n          top: 50%;\n          transform: translateY(-50%);\n          margin-right: 0.5rem;\n        ";
        case 'right':
            return "\n          left: 100%;\n          top: 50%;\n          transform: translateY(-50%);\n          margin-left: 0.5rem;\n        ";
    }
});
/**
 * Tooltip component for displaying helpful information on hover
 * 
 * @example
 * ```tsx
 * <Tooltip content="This is a tooltip">
 *   <button>Hover me</button>
 * </Tooltip>
 * 
 * <Tooltip content="Top tooltip" position="top">
 *   <span>Text with tooltip</span>
 * </Tooltip>
 * ```
 */ export var Tooltip = function(param) {
    var children = param.children, content = param.content, _param_position = param.position, position = _param_position === void 0 ? 'top' : _param_position, _param_delay = param.delay, delay = _param_delay === void 0 ? 300 : _param_delay, className = param.className, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled;
    var _useState = _sliced_to_array(useState(false), 2), visible = _useState[0], setVisible = _useState[1];
    var timeoutRef = useRef(null);
    var showTooltip = function() {
        if (disabled) return;
        timeoutRef.current = setTimeout(function() {
            setVisible(true);
        }, delay);
    };
    var hideTooltip = function() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setVisible(false);
    };
    useEffect(function() {
        return function() {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    if (disabled) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, children);
    }
    return /*#__PURE__*/ React.createElement(TooltipWrapper, {
        className: className,
        onMouseEnter: showTooltip,
        onMouseLeave: hideTooltip,
        onFocus: showTooltip,
        onBlur: hideTooltip
    }, children, content && /*#__PURE__*/ React.createElement(TooltipContent, {
        $position: position,
        $visible: visible,
        role: "tooltip",
        "aria-hidden": !visible
    }, content));
};
export default Tooltip;
